module.exports = __webpack_public_path__ + "img/eye.2d0f642f.svg";